export const getProcurementRequirementsInformation = state =>
  (state.procurement.data && state.procurement.data?.own_documents) ?? []
export const getProcurementVendorTypesInformation = state =>
  (state.procurement.data && state.procurement.data?.vendor_types) ?? []
